import { getAmountString, getRateString } from '../../helpers/humanization.js';

const getLeasingTerms = item => {
    // Платеж, удорожание в год., аванс от 0%
    const conditions = [];
    // платёж
    const { formulaMonthPayment } = item;
    if (formulaMonthPayment) {
        conditions.push({
            value: `от ${getAmountString(formulaMonthPayment)} ₽/мес`,
            description: 'Платёж',
            wide: true,
            key: 'formulaMonthPayment',
        });
    }
    // удорожание в год
    const { percentYear } = item;
    percentYear &&
        conditions.push({
            value: `от ${getRateString(percentYear)}`,
            description: 'Удорожание в год',
            key: 'percentYear',
        });
    // аванс от 0%
    const zeroInitial = item.advantages.includes('zeroInitial');
    conditions.push({ value: zeroInitial ? 'Да' : 'Нет', description: 'Аванс от 0%', key: 'zeroInitial' });
    return conditions;
};

export { getLeasingTerms };
//# sourceMappingURL=leasing.js.map
